import {Base} from "@/api/Base"

export class ServiceProviderEdit extends Base {
    path = "serviceProvider/edit"
}